"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSpecialtyAbbrDto = instanceOfSpecialtyAbbrDto;
exports.SpecialtyAbbrDtoFromJSON = SpecialtyAbbrDtoFromJSON;
exports.SpecialtyAbbrDtoFromJSONTyped = SpecialtyAbbrDtoFromJSONTyped;
exports.SpecialtyAbbrDtoToJSON = SpecialtyAbbrDtoToJSON;
exports.SpecialtyAbbrDtoToJSONTyped = SpecialtyAbbrDtoToJSONTyped;
/**
 * Check if a given object implements the SpecialtyAbbrDto interface.
 */
function instanceOfSpecialtyAbbrDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function SpecialtyAbbrDtoFromJSON(json) {
    return SpecialtyAbbrDtoFromJSONTyped(json, false);
}
function SpecialtyAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
    };
}
function SpecialtyAbbrDtoToJSON(json) {
    return SpecialtyAbbrDtoToJSONTyped(json, false);
}
function SpecialtyAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
    };
}
//# sourceMappingURL=SpecialtyAbbrDto.js.map